import { CHECKOUT_STATUS, CHECKOUT_TYPES } from '../../models/Checkout';
import { AddressSerializer } from './AddressSerializer';
import { BillingDataSerializer } from './BillingDataSerializer';
import { InstallationDataSerializer } from './InstallationDataSerializer';
import { ProductSerializer } from './ProductSerializer';
import { ShippingDataSerializer } from './ShippingDataSerializer';
import { GlossaryTextSerializer } from './GlossaryTextSerializer';
import { TextHelper } from '../../helpers/TextHelper';

const SERIALIZED_STATUS = {
  BILLED: 'Facturada',
  CONFIRMED: 'Confirmada',
  DISABLED: 'Anulada',
  PENDING: 'AConfirmar',
  PENDING_PAYMENT: 'PendienteDePago',
  REJECT_PAYMENT: 'PagoRechazado',
};

const SERIALIZED_TYPES = {
  ONLINE: 51,
  PHONE: 52,
  ON_SITE: 53,
};

class CheckoutSerializer {
  static deSerializeStatus(status) {
    switch (status) {
      case SERIALIZED_STATUS.CONFIRMED:
        return CHECKOUT_STATUS.CONFIRMED;
      case SERIALIZED_STATUS.BILLED:
        return CHECKOUT_STATUS.BILLED;
      case SERIALIZED_STATUS.DISABLED:
        return CHECKOUT_STATUS.DISABLED;
      case SERIALIZED_STATUS.PENDING:
        return CHECKOUT_STATUS.PENDING;
      case SERIALIZED_STATUS.PENDING_PAYMENT:
        return CHECKOUT_STATUS.PENDING_PAYMENT;
      case SERIALIZED_STATUS.REJECT_PAYMENT:
        return CHECKOUT_STATUS.REJECT_PAYMENT;
      default:
        return null;
    }
  }

  static deSerializeType(type) {
    switch (type) {
      case SERIALIZED_TYPES.ONLINE:
        return CHECKOUT_TYPES.ONLINE;
      case SERIALIZED_TYPES.ON_SITE:
        return CHECKOUT_TYPES.ON_SITE;
      case SERIALIZED_TYPES.PHONE:
        return CHECKOUT_TYPES.PHONE;
      default:
        return null;
    }
  }

  static deSerializeCart(cart, installations) {
    return cart.map((cartData) => {
      const product = ProductSerializer.deSerialize(cartData.Articulo);
      let serviceAmount = cartData.InstalacionesSinCoordinar || 0;
      installations.forEach((data) => {
        if (data.productId === product.id) {
          serviceAmount += data.selectedOptions.reduce((acc, opt) => (
            acc + opt.amount
          ), 0);
        }
      });
      return {
        product,
        amount: cartData.Cantidad,
        serviceAmount,
      };
    });
  }

  static deSerializeBank(bank) {
    return {
      consumidorFinal: bank.consumidorFinal ? 1 : 0,
      idBanco: bank.idBanco,
      idCuenta: bank.idCuenta,
      idFactura: bank.idFactura,
      idOrganismo: bank.idOrganismo,
      idTransaccion: bank.idTransaccion,
      importe: bank.importe,
      importeGravado: bank.importeGravado,
      moneda: bank.moneda,
      tipoServicio: bank.tipoServicio,
    };
  }

  static deSerializeBankType(bank) {
    return {
      id: bank.ID,
      name: bank.Nombre,
    };
  }

  static deSerialize(data) {
    // NOTE: the backend supports multiple shipments on one checkout
    // Here we only take the first, since the frontend doesn't support multiple
    // shipments.
    const shippingData = (data.Envios || [])[0] || null;
    const address = !shippingData ?
      null : AddressSerializer.deSerialize(shippingData.InfoDireccion);
    const installationData = (data.Instalaciones || []).map(InstallationDataSerializer.deSerialize);
    return {
      tokenBilling: data.TokenPDF,
      additionalNotes: data.Comentario,
      address,
      bank: data.Banco && CheckoutSerializer.deSerializeBankType(data.Banco),
      billingData: BillingDataSerializer.deSerialize(data.DatosFacturacion),
      cart: CheckoutSerializer.deSerializeCart(data.Articulos || [], installationData),
      cancellable: data.AdmiteCancelar || false,
      payable: data.AdmitePagoBanco || false,
      checkoutType: CheckoutSerializer.deSerializeType(data.TipoDePedido),
      date: new Date(data.Fecha),
      id: data.ID,
      information: TextHelper.separateIntoParagraphs(data.DetalleInfoPedido)
        .map(GlossaryTextSerializer.deSerialize),
      informationBottom: TextHelper.separateIntoParagraphs(data.DetalleInfoPedidoAbajo)
        .map(GlossaryTextSerializer.deSerialize),
      invoiceNumber: data.NumeroFactura,
      installationData,
      paymentType: data.FormaDePago,
      paymentTypeName: data.NombreFormaDePago,
      shippingData: shippingData ? ShippingDataSerializer.deSerialize(shippingData) : null,
      status: CheckoutSerializer.deSerializeStatus(data.Estado),
      statusMessage: data.DetalleInfoPedido,
      totalPrice: data.Total,
      requestBank: data.DatosPeticionBanco ?
        CheckoutSerializer.deSerializeBank(data.DatosPeticionBanco) : null,
    };
  }

  static deSerializePDF(data) {
    return {
      base64: data,
    };
  }
}

export { CheckoutSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/CheckoutSerializer.js